<template>
  <div class="shipping-section container">
    <div class="shipping-section__image-wrap">
      <img
        srcset="/static/images/shipping@2x.png"
        src="/static/images/shipping.png"
        class="shipping-section__image"
      >
    </div>
    <div class="shipping-section__content">
      <h4 class="shipping-section__title">Shipping to you or directly to your customers</h4>
      <div class="shipping-section__description">
        We make your order fulfillment super easy by delivering products directly to your customer’s door with cheap worldwide rates and fast shipping or we can package everything in container for delivery directly to your business.
      </div>
      <div class="shipping-section__info">
        <truck-icon />
        <span><strong>Offer fast worldwide shipping to your customers!</strong> We can ship quickly with incredibly low rates keeping your margins higher and customers happy.</span>
      </div>
    </div>
  </div>
</template>

<script>
import TruckIcon from 'static/assets/icons/TruckIcon.svg'

export default {
  name: 'ShippingSection',
  components: {
    TruckIcon,
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.shipping-section
  padding-bottom: 34px
  padding-top: 19px
  overflow: hidden

  @include tablet
    display: flex
    flex-direction: row-reverse

  @include widescreen
    max-width: 1200px
    padding-top: 8px
    padding-bottom: 0
    align-items: center

.shipping-section__content
  margin-top: 16px
  padding-left: 8px
  padding-right: 8px

  @include tablet
    margin-top: 0
    line-height: 32px

.shipping-section__title
  font-size: 28px
  font-weight: 500
  letter-spacing: -.5px
  padding-right: 10px
  color: #1d3763
  margin-bottom: 29px
  line-height: 32px

  @include tablet
    font-size: 35px
    line-height: 40px
    margin-bottom: 27px

  @include widescreen
    padding-right: 117px

.shipping-section__description
  color: #525f7f
  letter-spacing: .1px
  padding-right: 10px

  @include tablet
    line-height: 31px
    padding-right: 40px

.shipping-section__image-wrap
  margin-top: 7px
  width: 296px
  margin-left: auto
  margin-right: auto

  @include tablet
    margin-top: 0
    width: 50%
    flex-shrink: 0

  @include widescreen
    width: 660px
    position: relative
    right: -81px

.shipping-section__info
  display: flex
  align-items: flex-start
  margin-top: 23px
  font-size: 17px
  line-height: 26px
  letter-spacing: -.1px
  color: #525f7f

  @include tablet
    margin-top: 17px
    padding-right: 30px

  @include widescreen
    margin-top: 21px

  strong
    color: #404851
    font-weight: 600

  svg
    width: 47px
    height: 47px
    flex-shrink: 0
    margin-top: -4px
    margin-right: 24px
    position: relative
    left: -4px
</style>



// WEBPACK FOOTER //
// src/ShippingSection.vue